import { LabelLangString } from "component/LabelLang/label-lang";
import { END_POINTS } from "constants/APIConstant";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import useSWR from "swr";
import "./dropDownSearchComponent.scss";
const DropDownSearchComponent = ({ value, onChange }) => {
  const currentLocale = useSelector(({ theme }) => theme.locale);

  const subjectsFetching = useSWR({
    url: END_POINTS.SUBJECTS,
  });
  const subjectRendering = (title, translations) => {
    const subject = LabelLangString({
      id: "title",
      currentLocale: currentLocale,
      defaultValue: title,
      translations: translations,
    });
    return subject;
  };
  const renderDataCard = () => {
    const subjectData =
      subjectsFetching.error ||
      subjectsFetching.isLoading ||
      subjectsFetching.data === undefined
        ? []
        : subjectsFetching.data.data;
    const rendering =
      Object.keys(subjectData).length > 0
        ? 
        <>
          <option
            value={0}
          >
            <FormattedMessage id="choose-topic" />
          </option>
          {subjectData.map(({ title, subSubjects, subjectTranslations }, i) => (
            <optgroup
              key={i}
              label={subjectRendering(title, subjectTranslations)}
            >
              {subSubjects.map(({ title, subjectTranslations, id }, i) => (
                <option
                  key={i}
                  value={id}
                  title={LabelLangString({
                    id: "title",
                    currentLocale: currentLocale,
                    defaultValue: title,
                    translations: subjectTranslations,
                  })}
                >
                  {LabelLangString({
                    id: "title",
                    currentLocale: currentLocale,
                    defaultValue: title,
                    translations: subjectTranslations,
                  })}
                </option>
              ))}
            </optgroup>
          ))}
        </>
        : [];
    return rendering;
  };

  return (
    <div className="drop-down-search-component">
      <div className="search-bar">
        <Row style={{ width: "100%" }}>
          <Col xs={12} md={6} lg={4} xl={4} xxl={3}>
            <div className="title">
              <FormattedMessage id="search-according-subject" />
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="drop-down">
              <select value={value} onChange={onChange}>
                <option value="0">

                </option>
                {renderDataCard()}
              </select>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default DropDownSearchComponent;
